// // src/authConfig.js
// export const msalConfig = {
//   auth: {
//     clientId: "8cbc3472-640d-4e21-bef4-ec7ca969a16d", // Corrected CLIENT_ID
//     authority:
//       "https://login.microsoftonline.com/bfa3dfb0-91d5-4bf7-9a0c-fbf6ff337187", // Corrected TENANT_ID
//     redirectUri: "https://godrej.app-assertai.com/home", // Your callback URL
//   },
//   cache: {
//     cacheLocation: "localStorage", // This will store the cache in localStorage
//     storeAuthStateInCookie: true, // To avoid issues with IE11
//   },
// };

// // Scopes for authentication
// export const loginRequest = {
//   scopes: ["User.Read"],
// };

// // Token request (optional, if you want to acquire a token)
// export const tokenRequest = {
//   scopes: ["User.Read", "Mail.Read"],
// };
import { PublicClientApplication } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    clientId: "581cad47-e706-430a-ae19-375e15d99437",
    authority:
      "https://login.microsoftonline.com/bfa3dfb0-91d5-4bf7-9a0c-fbf6ff337187", // Adjust if using a specific tenant
    redirectUri: "https://godrej.app-assertai.com/home", // Change to your app's URI
    clientSecret: "9b4b909e-2060-4268-a103-890fd58f40c8",
  },
  cache: {
    cacheLocation: "sessionStorage", // This helps to avoid security risks
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["openid", "profile", "email", "User.Read"], // Include OpenID scope for OIDC
};

export const msalInstance = new PublicClientApplication(msalConfig);
